import { render, staticRenderFns } from "./TradeMain.vue?vue&type=template&id=6057cfd0&scoped=true&lang=pug"
import script from "./TradeMain.vue?vue&type=script&lang=js"
export * from "./TradeMain.vue?vue&type=script&lang=js"
import style0 from "./TradeMain.vue?vue&type=style&index=0&id=6057cfd0&prod&lang=less&scoped=true"
import style1 from "./TradeMain.vue?vue&type=style&index=1&id=6057cfd0&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6057cfd0",
  null
  
)

export default component.exports